// extracted by mini-css-extract-plugin
export default {"container":"_aa84f98a"};